import React from 'react';

import {
  DownloadLimitCategoryName,
  useManageDownloadLimitsModalQuery,
  useSaveDownloadLimitSettingMutation
} from 'generated/graphql';
import _ from 'lodash';
import { useLoading } from 'modules';



export interface IDownloadLimit {
  limit: number;
  categoryName: 'freeUsers' | 'paidUsers';
  categoryDisplayName: string;
}

export interface IData {
  limits: IDownloadLimit[];
}

export function useManageDownloadLimitsModal() {
  const tuple = useManageDownloadLimitsModalQuery();
  const [saveDownloadLimitSetting, saveDownloadLimitSettingTuple] = __useSaveDownloadLimitSettingMutation();
  const loading = useLoading([tuple, saveDownloadLimitSettingTuple]);



  const data = React.useMemo((): IData => ({
    limits: _.map(tuple.data?.downloadLimitSettings, (l): IDownloadLimit => ({
      limit: l.limit,
      categoryName: l.category.name,
      categoryDisplayName: l.category.displayName
    }))
  }), [tuple.data?.downloadLimitSettings]);



  return {
    loading,
    data,
    mutations: { saveDownloadLimitSetting }
  };
}



function __useSaveDownloadLimitSettingMutation() {
  const [fnMutate, tuple] = useSaveDownloadLimitSettingMutation();



  async function fnWrappedMutate(categoryName: DownloadLimitCategoryName, limit: number) {
    await fnMutate({
      variables: {
        categoryName,
        limit
      }
    });
  }



  return [
    fnWrappedMutate,
    {
      ...tuple,
      data: null
    }
  ] as const;
}
